/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import get from "lodash/get";
import { checkTeamSubscriptionActive } from "Utils/commonAPI";
import EmailInsightsComponent from "Components/common/EmailInsights";
import contactStoreData from "Stores/contactData";
import copilotStore from "Stores/copilotStore";
import DialerServiceData from "Stores/DialerServiceStore";
import {
  checkCallableNumber,
  notifyNoCallableNumber,
  CALL_GATE
} from "Global/commonUtils";
import { ReactComponent as DeleteIcon } from "Assets/svg/delete.svg";
import DropDownMenu from "Components/common/DropDownMenu";
import { toasterState } from "Components/common/toaster";
import { settingsStoreData } from "Stores/settingsData";
import Utils from "Utils/utils";
import { URLS, makeApi } from "Utils/apiURL";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import CustomTooltip from "Components/common/CustomTooltip";
import PaginationComponent from "Components/common/PaginationComponent";
import userDetail from "Stores/userDetail";
import CheckBox from "Components/common/CheckBox";
import { editContactPopupState } from "./EditContactPopup";
import AddContactBtn from "./AddContact";
import NoContactImg from "Assets/png/contact.png";
import ContactLoader from "./ContactLoader";
import { deselectCheckedPopupState } from "Components/common/DeselectCheckedPopup";
import FeatureDemoVideo from "Components/common/FeatureDemoVideo";
import { ReactComponent as MakeACallIcon } from "Assets/svg/call.svg";
import { ReactComponent as LogCallIcon } from "Assets/svg/callLog.svg";
import { ReactComponent as UpdateIcon } from "Assets/svg/update.svg";
import { ReactComponent as AccountIcon } from "Global/SideBar/Icons/accounts.svg";
import globalCallState from "Stores/GlobalCallState";
import { dialerLogsPopupState } from "Components/DailerService/DialerLogsAfterCallEndPopup";
import PaywallUtils from "Utils/PaywallUtils";
import { ContactUtils } from "Utils/ContactUtils";
import { customListState } from "Pages/Dashboard/dataSearch/CustomList/state";
import { updateContactOwnerState } from "Components/common/UpdateContactOwner";
import { MXP_EVENT } from "Static/MixPanelEvents";
import { pullContactState } from "../../ImportContactsFromLinkedIn/store";
import { importProgressJobs } from "../sequences/ProgressJobs/ImportProgressJobsStore";
import LinearProgressLoader from "Components/LinearProgressLoader";
const selectedOption = "";

const staticFields = [
  {
    displayName: "Actions",
    name: "action",
    key: "action",
    enabled: true
  }
];

const RenderContactTable = observer((props = {}) => {
  const {
    exportAllContactSelected,
    setExportAllContactSelected,
    setExportData,
    loading,
    tableLoadingFn = () => {},
    filterLoadingFn = () => {},
    contactData,
    contactUploading,
    setContactData,
    totalPages,
    selectedContactCard,
    activeTab,
    validContactUpload,
    checkEligibleContactCount,
    setContactUploading,
    contactLimit,
    allContactSelected,
    resetToSelectedCheckboxCbk = () => {},
    setSearchKeyword = () => {},
    setEmailClose = () => {},
    setActiveTab = () => {},
    contactFilterData = [],
    stageId = "",
    entireContactFilterData = [],
    setSelectedContactObj = () => {},
    updateContactOwnerCbk = () => {},
    setSelectedContactsNameList = () => {},
    selectedFilter = "",
    history = {},
    contactFields
  } = props || {};

  let userData = userDetail?.userFeatureFlag || {};

  const { inFreePlan = false, planName = "" } =
    userDetail?.userFeatureFlag || {};
  const { hasTeamMember = false } = userDetail?.userInfo || {};

  let settingsData = settingsStoreData.settingsData || {};

  const [showTooltip, setShowTooltip] = useState({});
  const [showUpdateDropDown, setShowUpdateDropDown] = useState(false);
  const [totalActiveBulkJobs, setTotalActiveBulkJobs] = useState(0);
  const [totalInProgressJobs, setTotalInprogressJobs] = useState(0);
  //For csv and Li Jobs
  const [isBulkContactUploading, setBulkContactUploading] = useState(false);
  const [totalProgressPercent, setTotalProgressPercent] = useState(0);

  // start of show edit contact popup
  const showEditContactPopup = async (id, showDropdown = true) => {
    showDropdown && showDropDownMenu(id, false);
    if ((await checkTeamSubscriptionActive()) && contactData?.contacts) {
      const contactsList = JSON.parse(JSON.stringify(contactData?.contacts));
      let contact = contactsList.find(item => {
        if (item?.id === id) {
          return item;
        }
      });
      if (contact) {
        contact = extractPhoneNumbersFromContact(contact);
        editContactPopupState.setContact(contact);
        editContactPopupState.setShowPopup(true);
        editContactPopupState.setCallback(handleUpdateContactSuccess);
      }
    }
  };

  const extractPhoneNumbersFromContact = contact => {
    // Preserve the full phone arrays — EditContactPopup handles arrays correctly.
    // Truncating to the first element here caused silent data loss on save.
    return contact;
  };

  const handleUpdateContactSuccess = (contact = {}, updatedTags) => {
    if (!contactStoreData?.updateContactEmail) {
      let contactList = contactData?.contacts || [];
      const updatedContactList = contactList.map(item => {
        if (item?.id === contact?.id) {
          modifyTableDataFromResponse(item, contact, updatedTags);
        }
        return item;
      });
      contactData.contacts = updatedContactList;
      setContactData(contactData);
    }
    contactStoreData.setUpdateContactEmail("");
  };

  const modifyTableDataFromResponse = (
    tableData,
    responseData,
    updatedTags
  ) => {
    tableData.name = responseData.firstName;
    tableData.firstName = responseData.firstName;
    tableData.lastName = responseData.lastName;
    tableData.email = responseData.email;
    tableData.phone = responseData.phone;
    tableData.linkedinId = responseData.linkedinId;
    tableData.jobTitle = responseData.jobTitle;
    tableData.company = responseData.company;
    tableData.mobilePhone = responseData.mobilePhone;
    tableData.otherPhone = responseData.otherPhone;
    tableData.industry = responseData.industry;
    tableData.street = responseData.street;
    tableData.city = responseData.city;
    tableData.state = responseData.state;
    tableData.country = responseData.country;
    tableData.zipCode = responseData.zipCode;
    tableData.website = responseData.website;
    tableData.facebook = responseData.facebook;
    tableData.twitter = responseData.twitter;
    tableData.contactNotes = responseData.contactNotes;
    tableData.customFields = responseData.customFields;
    tableData.contactTags = updatedTags;
    return tableData;
  };

  const deleteContact = async id => {
    showDropDownMenu(id, false);
    if (await checkTeamSubscriptionActive()) {
      if (id) {
        const deleteContactCbk = async buttonLoadingFn => {
          const targetContact = findCurrentContact(id);
          if (targetContact) {
            const response = await deleteContactApi(targetContact.id);
            buttonLoadingFn(false);
            confirmationPopupState.setShowPopup(false);
            if (response?.status) {
              const respStatus = response.status;
              if (respStatus === 200) {
                userData.noOfContactsUsed -= 1;
                userDetail.setUserFeatureFlag(userData);
                handleContactDeleteSccess();
              } else {
                handleContactDeleteFailure();
              }
            } else if (response?.response?.status) {
              const respStatus = response.response.status;
              if (respStatus === 403) {
                toasterState.setToastMsg(
                  "You don't have deleting access to this contact",
                  "failure"
                );
              } else if (respStatus === 426) {
                Utils.showAccountSuspendedPopup();
              } else {
                handleContactDeleteFailure();
              }
            }
          }
        };

        confirmationPopupState.setPopupValues({
          title: "Are you sure",
          content:
            "Are you sure you want to delete this contact?<br/>All the scheduled emails and open tasks for this contact will be canceled.",
          actionBtnText: "Yes",
          callback: deleteContactCbk,
          loadingMsg: "Deleting contact. Please wait..."
        });
        confirmationPopupState.setShowPopup(true);
      }
    }
  };

  const updateStageApiCall = async (contactId, stageId, stageName, emailId) => {
    let payload = {
      contactId,
      stageId
    };
    const config = {
      url: URLS.updateStageInDirectory,
      method: "POST",
      data: payload
    };
    const response = await makeApi(config);
    handleApiResponse(response, stageId, stageName, emailId);
  };

  const handleApiResponse = (response, stageId, stageName, emailId) => {
    const responseCode = response?.status || "";
    if (responseCode === 200) {
      contactStoreData.filterContactAnalyticsData(
        contactStoreData.filterPayload,

        () => {}
      );
      let message = "Contact stage updated successfully.";
      let contactList = contactData?.contacts || [];
      const updatedContactList = contactList.map(e => {
        if (e?.id === emailId) {
          e.stageDisplayName = stageName;
          e.stageId = stageId;
        }
        return e;
      });
      contactData.contacts = updatedContactList;
      setContactData(contactData);
      toasterState.setToastMsg(message, "success");
    } else if (responseCode === 403) {
      let message = "You don't have editing access to this contact";
      toasterState.setToastMsg(message, "failure");
    } else toasterState.setToastMsg("Failed to updated contact", "failure");
  };

  const updateStage = (emailId, stageParam) => {
    let contact = null,
      contactId = null;
    let contactList = contactData?.contacts || [];
    const updatedContactList = contactList.map(e => {
      if (e?.id === emailId) {
        contact = e;
        e.showContactDropDown = false;
        contactId = e.id;
      }
      return e;
    });
    contactData.contacts = updatedContactList;
    setContactData(contactData);
    if (contactId) {
      updateStageApiCall(
        contactId,
        stageParam?.key,
        stageParam?.value,
        emailId
      );
    }
  };

  const updateStageDropDown = () => {
    setShowUpdateDropDown(!showUpdateDropDown);
  };

  const deleteContactApi = id => {
    const config = {
      url: URLS.addContactsToDirectory,
      method: "DELETE",
      data: { id }
    };
    return makeApi(config);
  };

  const handleContactDeleteSccess = () => {
    toasterState.setToastMsg("Contact deleted successfully", "success");
    customListState.getContactList();
    filterLoadingFn(true);
    tableLoadingFn(true);
    setExportData([]);
    setSelectedContactObj([]);
    setSelectedContactsNameList([]);
    setExportAllContactSelected(false);
    ContactUtils.contactFilterByPayload(
      contactStoreData.filterPayload,
      tableLoadingFn,
      filterLoadingFn,
      true
    );
  };

  const handleContactDeleteFailure = () => {
    toasterState.setToastMsg(
      "Contact delete failed. Please try again later",
      "failure"
    );
  };

  const optOutContact = async id => {
    showDropDownMenu(id, false);
    if (await checkTeamSubscriptionActive) {
      if (id) {
        const selectedContact = findCurrentContact(id);
        const name = selectedContact?.name;
        const optOutContactCbk = async buttonLoadingFn => {
          if (selectedContact) {
            const response = await optOutContactThrouhgApi(selectedContact.id);
            const respStatus =
              response?.status || response?.response?.status || "";
            if (respStatus === 200) {
              handleOptOutContactSuccess(selectedContact);
              toasterState.setToastMsg(`${name} was opted out`, "success");
              ContactUtils.contactFilterByPayload(
                contactStoreData?.filterPayload,
                tableLoadingFn,
                filterLoadingFn,
                true
              );
            } else if (respStatus === 403) {
              toasterState.setToastMsg(
                "You don't have access to this contact",
                "failure"
              );
            }
            buttonLoadingFn(false);
            confirmationPopupState.setShowPopup(false);
          }
        };

        confirmationPopupState.setPopupValues({
          content: `Are you sure you want to Opt out ${name}? The contact will be opted out from all sequences they are currently in.`,
          actionBtnText: "Yes",
          callback: optOutContactCbk,
          loadingMsg: "Opting out the contact. Please wait..."
        });
        confirmationPopupState.setShowPopup(true);
      }
    }
  };

  const optOutContactThrouhgApi = contactId => {
    const config = {
      url: URLS.optOutContact,
      method: "POST",
      data: { contactId }
    };
    return makeApi(config);
  };

  const handleOptOutContactSuccess = contact => {
    contactStoreData.filterContactAnalyticsData(
      { ...contactStoreData.filterPayload, stageId },
      () => {}
    );

    let contactList = contactData?.contacts || [];
    const updatedContactList = contactList.map(e => {
      if (e?.id === contact?.id) {
        e.stage = "OPTED_OUT";
        e.showContactDropDown = false;
      }
      return e;
    });
    contactData.contacts = updatedContactList;
    setContactData(contactData);
  };

  const openDailerServiceCard = async contact => {
    showDropDownMenu(contact?.id, false);
    if (
      contact &&
      contact?.stageDisplayName?.toLowerCase() === "do not contact"
    ) {
      toasterState.setToastMsg(
        "Oops! You cannot make call for a contact with 'do not contact' stage.",
        "failure"
      );
    } else {
      if (await checkTeamSubscriptionActive()) {
        if (userData?.dialerEnabled !== "") {
          if (userData?.dialerEnabled) {
            const callGate = await checkCallableNumber(userData?.indiaCallingEnabled);
            if (callGate === CALL_GATE.OK) {
              await DialerServiceData.getDailerToken();
              DialerServiceData.setDialerCallLogs(false);
              globalCallState.setPopupValues({
                ...globalCallState.popupValues,
                ...{ isFromContactSection: true, contactData: contact || {} }
              });
              globalCallState.setShowCallSlider(true);
              Utils.mixpanelTrack(MXP_EVENT.MAKE_CALL_CLICKED, {
                pageType: "Contacts Page",
                type: "Contact more option"
              });
            } else {
              notifyNoCallableNumber(callGate);
            }
          } else {
            PaywallUtils.upgradeUtilsFunction(
              "dialer",
              false,
              planName,
              inFreePlan
            );
          }
        } else {
          toasterState.setToastMsg("Please wait...", "info");
        }
      }
    }
  };

  const openCallLogPopup = (id = "") => {
    let contactList = [...contactData?.contacts] || [];
    let tempContact = {};
    const updatedContactList = contactList.map(item => {
      if (item?.id === id) {
        tempContact = item;
        item.showContactDropDown = false;
      }
      return item;
    });
    setContactData({ ...contactData, contacts: updatedContactList });
    if (tempContact) {
      dialerLogsPopupState.setActionType("SINGLE_CONTACT");
      dialerLogsPopupState.setContactData(tempContact);
      dialerLogsPopupState.setShowLogCallPopup(true);
    }
  };

  const openAssignContactOwnerPopup = (id = "", showDropdown = false) => {
    showDropdown && showDropDownMenu(id, false);
    const targetContact = findCurrentContact(id);
    const handleCallback = (selectedOwnerId = "") => {
      updateContactOwnerCbk(selectedOwnerId, "single", targetContact?.id);
    };
    updateContactOwnerState.setCurrentOwnerEmail(
      targetContact?.owner?.email || ""
    );
    updateContactOwnerState.setTotalCount(1);
    updateContactOwnerState.setCallback(handleCallback);
    updateContactOwnerState.setShowPopup(true);
  };

  const viewContactAccount = (id, showDropdown = false) => {
    if (id) {
      showDropdown && showDropDownMenu(id, false);
      let { accountId = "" } = findCurrentContact(id);
      accountId && history.push(`/accounts/${accountId}/overview`);
    }
  };

  const askCopilotAboutContact = (id = "") => {
    showDropDownMenu(id, false);
    const contact = (contactData?.contacts || []).find(item => item?.id === id);
    const name =
      [contact?.firstName, contact?.lastName].filter(Boolean).join(" ") ||
      contact?.email ||
      "this contact";
    copilotStore.askWithQuery(
      `Prep me for reaching out to ${name} (contact id ${id}) — who they are, engagement so far, and a suggested next step.`
    );
  };

  const dropdownOptions = [
    // Disabled for this release — askWithQuery opens CopilotWidget, which is not mounted, so this did nothing when clicked.
    // {
    //   icon: {
    //     ele: '<i style="font-size: 15px" class="material-icons-outlined">auto_awesome</i>',
    //     style: { width: "15px", height: "15px" }
    //   },
    //   value: "Ask Copilot",
    //   key: "askCopilot",
    //   method: askCopilotAboutContact
    // },
    hasTeamMember && {
      icon: {
        ele: '<i style="font-size: 15px" class="material-icons-outlined">person_pin</i>',
        style: { width: "15px", height: "15px" }
      },
      value: "Update Owner",
      key: "updateOwner",
      method: openAssignContactOwnerPopup
    },
    {
      icon: {
        ele: '<i style="font-size: 15px" class="material-icons-outlined list-icon">edit</i>',
        style: { width: "15px", height: "15px" }
      },
      value: "Edit",
      key: "Edit",
      method: showEditContactPopup
    },
    {
      icon: {
        ele: <MakeACallIcon />,
        style: { width: "16px", height: "16px" }
      },
      value: "Call",
      key: "Call",
      method: openDailerServiceCard,
      showUpgrade: !userData?.dialerEnabled,
      type: "callContact",
      plan: "proPlan"
    },
    {
      icon: {
        ele: <LogCallIcon />,
        style: { width: "16px", height: "16px" }
      },
      value: "Log call",
      key: "Log call",
      method: openCallLogPopup
    },
    {
      icon: { ele: <DeleteIcon />, style: { width: "16px", height: "16px" } },
      value: "Delete",
      key: "Delete",
      method: deleteContact
    }
  ];

  const viewAccountsOption = {
    icon: { ele: <AccountIcon />, style: { width: "16px", height: "16px" } },
    value: "View Account",
    key: "viewAccount",
    method: viewContactAccount
  };

  const getUpdatedOptions = disabled => {
    return [
      {
        icon: { ele: <UpdateIcon />, style: { width: "16px", height: "16px" } },
        value: "Update Stage",
        key: "Update Stage",
        method: updateStageDropDown,
        disabled
      }
    ];
  };

  const getOptedOutOptions = showOptedOut => {
    return !showOptedOut
      ? [
          {
            icon: {
              ele: '<i style="font-size: 15px" class="material-icons-outlined list-icon">block</i>',
              style: { width: "15px", height: "15px" }
            },
            value: "Opt out",
            key: "optout",
            method: optOutContact
          }
        ]
      : [];
  };

  const construcstageOptions = () => {
    let temp = [];
    entireContactFilterData.forEach(element => {
      let nameCheck = element?.name?.toLowerCase();
      if (!["bounced", "opted out", "total", "no stage"].includes(nameCheck)) {
        temp.push({
          value: element?.name,
          key: element?.id,
          method: updateStage
        });
      }
    });
    return temp;
  };
  const stageOptions = [...construcstageOptions(contactFilterData)];

  const paginate = pageNoObj => {
    if (!loading) {
      let pageNo = pageNoObj?.selected + 1 || 1;
      contactStoreData.setCurrentPage(pageNo);
      setExportData([]);
      setSelectedContactObj([]);
      setSelectedContactsNameList([]);
      setExportAllContactSelected(false);
      tableLoadingFn(true);
      let payload = { ...contactStoreData.filterPayload, pageNo };
      contactStoreData.setFilterPayload(payload);
      contactStoreData.filterContactData(payload, tableLoadingFn);
    }
  };

  const showDropDownMenu = (id, arg, referenceEle) => {
    if (!arg) {
      setShowUpdateDropDown(false);
    }
    if (id) {
      let contactList = contactData && contactData.contacts;
      const updatedContactList = contactList.map(e => {
        if (e.id === id) {
          if (referenceEle) {
            e.positionY = referenceEle.pageY;
          }
          if (arg) {
            e.showContactDropDown = false;
            setShowUpdateDropDown(false);
          } else {
            e.showContactDropDown = !e.showContactDropDown;
          }
        }
        return e;
      });
      contactData.contacts = updatedContactList;
      setContactData(contactData);
    }
  };

  const findCurrentContact = id => {
    const contactList = contactData.contacts;
    if (contactList) {
      return contactList.find(arrayValue => arrayValue.id === id);
    }
  };

  const getFullName = (name, fName, lName) => {
    if (fName && lName) {
      return `${fName} ${lName}`;
    } else if (name && name.trim().length > 0) {
      return name;
    } else if (fName) {
      return fName;
    } else if (lName) {
      return lName;
    }
    return "";
  };

  const getContactName = (name, fName, lName, contact) => {
    return (
      (fName || lName) && (
        <div
          className="name triggerContactCard underlineHighlight"
          onClick={() => slideContactCard(contact)}
        >
          {getFullName(name, fName, lName)}
        </div>
      )
    );
  };

  const markSelectedContact = (value, contactId) => {
    if (allContactSelected) {
      deselectCheckedPopupState.setPopupValues({
        callback: resetToSelectedCheckboxCbk
      });
      deselectCheckedPopupState.setPopup(true);
    } else {
      if (contactId === "all") {
        setExportAllContactSelected(value);
        toggleSelectAllTableContact();
        constructExportData("all", value);
      } else {
        setExportAllContactSelected(false);
        toggleSelectContactById(contactId);
        constructExportData();
      }
    }
  };

  const toggleSelectContactById = contactId => {
    if (contactId) {
      contactData?.contacts &&
        contactData.contacts.map(value => {
          value?.id === contactId && (value.isSelected = !value.isSelected);
        });
      setContactData(contactData);
    }
  };

  const toggleSelectAllTableContact = () => {
    contactData?.contacts &&
      contactData.contacts.map(value => {
        if (value?.id) {
          if (exportAllContactSelected) {
            value.isSelected = false;
            setExportAllContactSelected(false);
          } else {
            value.isSelected = true;
          }
        }
      });
    setContactData(contactData);
  };

  const constructExportData = (flag, value) => {
    const tempArr = [];
    const contactIdAndStageObj = [];
    const tempSelectedNames = [];
    contactData.contacts.map(value => {
      if (value?.id && (value?.isSelected || flag === "all")) {
        const {
          firstName = "",
          lastName = "",
          name = "",
          email = ""
        } = value || {};
        let contactName = Utils.getName(firstName, lastName, name, email);
        tempArr.push(value.id);
        tempSelectedNames.push(contactName);
        contactIdAndStageObj.push({
          id: value.id,
          stageName: value?.stageDisplayName,
          email: value?.email
        });
      }
    });
    setExportData(flag === "all" ? (value ? tempArr : []) : tempArr);
    setSelectedContactObj(
      flag === "all"
        ? value
          ? contactIdAndStageObj
          : []
        : contactIdAndStageObj
    );

    setSelectedContactsNameList(tempSelectedNames);
  };

  const slideContactCard = contact => {
    selectedContactCard(contact);
  };

  const showDemoVideoCard = () => {
    return (
      !(
        contactData &&
        Object.keys(contactData)?.length &&
        contactData?.totalContacts > 0
      ) && activeTab === "total"
    );
  };

  const getStage = (stageDisplayName, stage) => {
    stage = stage?.toLowerCase();
    const className = stage === "opted_out" ? "optedout" : stage;

    return (
      <div className="status">
        <div className="stageCont">
          <span className={`stage ${className}`}>{stageDisplayName}</span>
        </div>
      </div>
    );
  };

  //Fetches the total active and Inprogress Bulk jobs
  const fetchBulkContactJobs = () => {
    contactStoreData.getBulkJobImportTracking();
  };

  const getAllJobs = () => {
    pullContactState.getAllLiJobStatus();
    contactStoreData.getBulkJobImportTracking();
  };

  const calculateProcessingTime = (contactCount = 1) => {
    return contactCount > 0
      ? (10 + Math.floor(contactCount / 1000) * 4) * 1000
      : 0;
  };

  useEffect(() => {
    settingsData = settingsStoreData.settingsData;
  }, [settingsStoreData.settingsData]);

  useEffect(() => {
    if (!contactStoreData?.updateContactEmail && customListState?.activeList) {
      let payload = {
        ...contactStoreData.filterPayload,
        pageNo: 1,
        listId: customListState?.activeList?.id
      };
      tableLoadingFn(true);
      filterLoadingFn(true);
      contactStoreData.setFilterPayload(payload);
      ContactUtils.contactFilterByPayload(
        payload,
        tableLoadingFn,
        filterLoadingFn,
        true,
        false
      );
    }
  }, [customListState?.activeList]);

  useEffect(() => {
    if (!contactStoreData?.updateContactEmail) {
      setSearchKeyword("");
      setEmailClose(false);
      contactStoreData.setSearchContactFilter("total");
      setActiveTab("total");
      contactStoreData.setCurrentPage(1);
    }
  }, []);

  useEffect(() => {
    if (selectedFilter !== "" && selectedFilter === false) {
      if (!selectedFilter) {
        let payload = {
          filter: {},
          stageId: "",
          pageNo: 1,
          searchTerm: "",
          listId: customListState?.activeList?.id
        };
        tableLoadingFn(true);
        ContactUtils.contactFilterByPayload(
          payload,
          tableLoadingFn,
          filterLoadingFn,
          true,
          false
        );
      }
    }
  }, [selectedFilter]);

  useEffect(() => {
    if (contactStoreData?.updateContactEmail && contactData?.contacts) {
      showEditContactPopup(contactStoreData?.updateContactEmail, false);
    }
  }, [contactStoreData.updateContactEmail, contactData.contacts]);

  useEffect(() => {
    getAllJobs();
  }, []);

  useEffect(() => {
    let interval;
    if (
      pullContactState?.liJobStatus &&
      pullContactState?.liJobStatus?.status
    ) {
      const totalContactsToImport = pullContactState?.liJobStatus?.jobs.reduce(
        (acc, curr) => {
          const total = curr?.job?.totalContacts || 0;
          const imported = curr?.job?.noOfContactsImported || 0;
          const remaining = Math.max(total - imported, 0);
          return acc + remaining;
        },
        0
      );

      if (totalContactsToImport > 0) {
        const pollingInterval = calculateProcessingTime(totalContactsToImport);

        interval = setInterval(() => {
          try {
            pullContactState.getAllLiJobStatus();
          } catch (error) {
            console.error("Error while fetching LI job status", error);
          }
        }, pollingInterval);
      }
    }
    return () => {
      clearInterval(interval);
    };
  }, [pullContactState?.liJobStatus]);

  useEffect(() => {
    let interval;
    let pollingInterval = 30000;
    const hasCsvJobs =
      importProgressJobs?.totalCsvActiveJobs > 0 ||
      importProgressJobs?.totalCsvInProgressJobs > 0;
    if (hasCsvJobs) {
      const inprogressCsvJobs = Utils.getJobsByStatus(
        importProgressJobs?.csvImportJobs,
        "INPROGRESS"
      );

      if (inprogressCsvJobs.length > 0) {
        const totalCsvContacts = inprogressCsvJobs.reduce((acc, curr) => {
          return acc + curr.totalContacts;
        }, 0);
        pollingInterval = Math.max(
          Utils.calculateJobsProcessingTime(totalCsvContacts),
          30000
        );
      }

      interval = setInterval(() => {
        try {
          fetchBulkContactJobs();
        } catch (e) {
          console.error("Error fetching contacts bulk job");
        }
      }, pollingInterval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [
    importProgressJobs?.csvImportJobs,
    importProgressJobs?.totalCsvActiveJobs,
    importProgressJobs?.totalCsvInProgressJobs
  ]);

  //Setting total to be processed jobs (LI & CSV)
  useEffect(() => {
    setTotalActiveBulkJobs(
      importProgressJobs?.totalCsvActiveJobs +
        importProgressJobs?.totalLiActiveJobs
    );
  }, [
    importProgressJobs?.totalCsvActiveJobs,
    importProgressJobs?.totalLiActiveJobs
  ]);

  //Setting total In progress jobs (LI & CSV)
  useEffect(() => {
    setTotalInprogressJobs(
      importProgressJobs?.totalCsvInProgressJobs +
        importProgressJobs?.totalLiInProgressJobs
    );
  }, [
    importProgressJobs?.totalCsvInProgressJobs,
    importProgressJobs?.totalLiInProgressJobs
  ]);

  useEffect(() => {
    setBulkContactUploading(
      importProgressJobs?.totalCsvActiveJobs +
        importProgressJobs?.totalCsvInProgressJobs +
        importProgressJobs?.totalLiActiveJobs +
        importProgressJobs?.totalLiInProgressJobs >
        0
    );
  }, [
    importProgressJobs?.totalCsvActiveJobs,
    importProgressJobs?.totalCsvInProgressJobs,
    importProgressJobs?.totalLiActiveJobs,
    importProgressJobs?.totalLiInProgressJobs
  ]);

  useEffect(() => {
    if (
      importProgressJobs?.totalCsvActiveJobs +
        importProgressJobs?.totalCsvInProgressJobs +
        importProgressJobs?.totalLiActiveJobs +
        importProgressJobs?.totalLiInProgressJobs >
      0
    ) {
      const totalPercent = Utils.getWorkloadWeightedProgress(
        importProgressJobs?.csvImportJobs,
        importProgressJobs?.liImportJobs
      );
      setTotalProgressPercent(totalPercent);
    } else {
      setTotalProgressPercent(0);
    }
  }, [
    importProgressJobs?.csvImportJobs,
    importProgressJobs?.liImportJobs,
    importProgressJobs?.totalCsvActiveJobs,
    importProgressJobs?.totalCsvInProgressJobs,
    importProgressJobs?.totalLiActiveJobs,
    importProgressJobs?.totalLiInProgressJobs
  ]);

  return (
    <>
      <div className="contactTable">
        <div className="contactBody" id="overflowCont">
          <div
            className="contactBodyInner"
            onScroll={Utils.handleStickyColumnInTable}
          >
            {isBulkContactUploading && (
              <LinearProgressLoader
                progress={totalProgressPercent}
                totalActiveBulkJobs={totalActiveBulkJobs}
                totalInProgressJobs={totalInProgressJobs}
              />
            )}
            <table>
              <thead>
                <tr className="ctTableHeader">
                  <th className="ctSelectAll">
                    {loading ? (
                      <div></div>
                    ) : (
                      contactData?.contacts?.length && (
                        <CheckBox
                          key="allContactsCheck"
                          id="all"
                          checked={exportAllContactSelected}
                          cbk={markSelectedContact}
                          allContactsChecked={allContactSelected}
                        />
                      )
                    )}
                  </th>
                  {contactFields.map(contactField => {
                    const {
                      displayName,
                      headerClassName = "",
                      enabled
                    } = contactField;
                    return (
                      enabled && (
                        <th key={displayName} className={headerClassName}>
                          <div>{displayName}</div>
                        </th>
                      )
                    );
                  })}
                  <th>
                    <div>Actions</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isBulkContactUploading && (
                  <tr className="loaderPlaceholderRow">
                    <td
                      colSpan={
                        contactFields?.filter(field => field.enabled).length
                      }
                    ></td>
                  </tr>
                )}
                {!loading ? (
                  contactData?.contacts?.length > 0 &&
                  contactData.contacts.map((contact, key) => {
                    let {
                      id,
                      firstName,
                      lastName,
                      email,
                      name,
                      insights,
                      company,
                      jobTitle,
                      stage,
                      lastContacted,
                      contactTags,
                      owner,
                      isSelected,
                      stageDisplayName,
                      accountId = ""
                    } = contact || {};
                    const defaultStage = stage;
                    stage =
                      stage &&
                      stage.length &&
                      stage.toLowerCase().replace("_", " ");
                    const options = {
                      year: "numeric",
                      month: "short",
                      day: "numeric"
                    };
                    lastContacted =
                      lastContacted &&
                      new Date(lastContacted).toLocaleDateString(
                        "en-US",
                        options
                      );

                    return (
                      <tr
                        key={key}
                        className="ctTableBody"
                        onClick={() => slideContactCard(contact)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="ctSelectAll" onClick={e => e.stopPropagation()}>
                          <CheckBox
                            key="autoBcc"
                            id={id}
                            checked={isSelected || false}
                            cbk={markSelectedContact}
                          />
                        </td>

                        {contactFields.map((field, idx) => {
                          const {
                            key: fieldKey,
                            headerClassName,
                            enabled
                          } = field;

                          if (!enabled) return;
                          switch (fieldKey) {
                            case "name":
                              return (
                                <td key={fieldKey} className="nameWrapper">
                                  {getContactName(
                                    name,
                                    firstName,
                                    lastName,
                                    contact
                                  )}
                                </td>
                              );
                            case "email":
                              return (
                                <td key={fieldKey}>
                                  <span
                                    className="email triggerContactCard underlineHighlight"
                                    onClick={() => slideContactCard(contact)}
                                  >
                                    {email}
                                  </span>
                                </td>
                              );
                            case "linkedinId":
                              const linkedinUrl = get(contact, fieldKey);
                              return (
                                <td
                                  key={fieldKey}
                                  className={headerClassName || ""}
                                >
                                  {linkedinUrl ? (
                                    <p
                                      className="linkedin-wrapper"
                                      title={linkedinUrl}
                                      onClick={e => e.stopPropagation()}
                                    >
                                      <a
                                        href={
                                          linkedinUrl.startsWith("http")
                                            ? linkedinUrl
                                            : `https://${linkedinUrl}`
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="linkedin-link"
                                      >
                                        {linkedinUrl}
                                      </a>
                                    </p>
                                  ) : (
                                    "--"
                                  )}
                                </td>
                              );
                            case "jobTitle":
                              return (
                                <td key="jobTitle" className="companyJobTile">
                                  <p title={jobTitle} className="job">
                                    {jobTitle}
                                  </p>
                                </td>
                              );
                            case "company":
                              return (
                                <td key="company" className="companyJobTile">
                                  <p title={company} className="company">
                                    {company}
                                  </p>
                                </td>
                              );
                            case "contactTags":
                              return (
                                <td key={fieldKey} className="tag">
                                  {ContactUtils.getTagNameDom(contactTags)}
                                </td>
                              );
                            case "stageDisplayName":
                              return (
                                <td key={fieldKey} className="status" onClick={e => e.stopPropagation()}>
                                  {getStage(stageDisplayName, defaultStage)}
                                </td>
                              );
                            case "insights":
                              return (
                                <td key={fieldKey} className="stageInsight" onClick={e => e.stopPropagation()}>
                                  {insights !== "undefined" &&
                                  insights !== null &&
                                  Object.keys(insights).length > 0 ? (
                                    <EmailInsightsComponent
                                      emailInsight={insights}
                                    />
                                  ) : (
                                    "--"
                                  )}
                                </td>
                              );
                            case "lastContacted":
                              return (
                                <td key={fieldKey} className="lastContacted">
                                  <div className="lastContacted column">
                                    {lastContacted || "--"}
                                  </div>
                                </td>
                              );
                            case "owner":
                              return (
                                <td
                                  key="owner"
                                  className="ctOwner"
                                  onMouseEnter={() =>
                                    setShowTooltip({ key, value: true })
                                  }
                                  onMouseLeave={() =>
                                    setShowTooltip({ key, value: false })
                                  }
                                >
                                  {(owner && (
                                    <div>
                                      <span className="circleOwner">
                                        {Utils.getOwnerInitial(owner)}
                                      </span>
                                      {showTooltip.key === key &&
                                        showTooltip.value && (
                                          <CustomTooltip
                                            text={`Added by ${Utils.getOwnerName(
                                              owner
                                            )}`}
                                          />
                                        )}
                                    </div>
                                  )) ||
                                    "--"}
                                </td>
                              );
                            default: {
                              let value;
                              value = get(contact, fieldKey) || "--";
                              if (
                                fieldKey === "website" &&
                                field.displayName === "Personal Website"
                              ) {
                                return <td></td>;
                              }
                              if (
                                fieldKey === "website" &&
                                field.displayName !== "Personal Website"
                              ) {
                                const websiteUrl = get(contact, fieldKey);
                                return (
                                  <td
                                    key={fieldKey}
                                    className={headerClassName || ""}
                                  >
                                    {websiteUrl ? (
                                      <p className="website-wrapper" title={websiteUrl} onClick={e => e.stopPropagation()}>
                                        <a
                                          href={
                                            websiteUrl.startsWith("http")
                                              ? websiteUrl
                                              : `https://${websiteUrl}`
                                          }
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {websiteUrl}
                                        </a>
                                      </p>
                                    ) : (
                                      "--"
                                    )}
                                  </td>
                                );
                              }
                              return (
                                <td
                                  key={fieldKey}
                                  className={headerClassName || ""}
                                >
                                  <p
                                    title={
                                      typeof value === "string"
                                        ? value
                                        : undefined
                                    }
                                  >
                                    {value}
                                  </p>
                                </td>
                              );
                            }
                          }
                        })}
                        <td
                          key="action"
                          className={`actionDp moreOption ${contact.showContactDropDown ? "activeRow" : ""
                            }`}
                        >
                          <div>
                            <i
                              className="material-icons-outlined icon-hover-btn"
                              onClick={e => {
                                e.stopPropagation();
                                showDropDownMenu(id, null, e)
                              }}
                              title="More Options"
                            >
                              more_vert
                            </i>
                            <div style={{ position: "relative" }}>
                              {contact.showContactDropDown && (
                                <>
                                  <DropDownMenu
                                    options={[
                                      ...getUpdatedOptions(
                                        stage === "opted out" ||
                                          stage === "bounced"
                                      ),
                                      ...dropdownOptions,
                                      ...getOptedOutOptions(
                                        stage === "opted out"
                                      ),
                                      accountId && viewAccountsOption
                                    ].filter(Boolean)}
                                    selected={selectedOption}
                                    referenceId={id}
                                    direction={
                                      key >= 0 && key <= 1 ? "topLeft" : "left"
                                    }
                                    parentPosition={contact.positionY}
                                    contact={contact}
                                  />
                                  {showUpdateDropDown &&
                                    !["opted out", "bounced"]?.includes(
                                      stage
                                    ) && (
                                      <DropDownMenu
                                        options={stageOptions}
                                        referenceId={id}
                                        direction={"bottomUp"}
                                        parentPosition={contact.positionY}
                                        contact={contact}
                                      />
                                    )}

                                  <div
                                    className="dropdownMask"
                                    onClick={e => showDropDownMenu(id, false)}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <ContactLoader
                    count={contactLimit}
                    contactFields={contactFields.concat(staticFields)}
                  />
                )}
              </tbody>
            </table>
            {contactUploading ? (
              <div className="contactUploadLoader">
                <div className="circleLoader animatedButton loading">
                  <span className="load-text"></span>
                </div>
                &nbsp;We are processing your contacts
              </div>
            ) : (
              (contactData?.contacts === null ||
                contactData?.contacts?.length === 0) &&
              !loading && (
                <div className="add-contact-stage">
                  {activeTab !== "total" && (
                    <>
                      <i className="material-icons-outlined">
                        supervisor_account
                      </i>
                      No Contacts Found
                    </>
                  )}
                  {showDemoVideoCard() && (
                    <>
                      <img src={NoContactImg} alt="" />
                      <h6>Add Contacts</h6>
                      <AddContactBtn
                        validContactUpload={validContactUpload}
                        checkEligibleContactCount={checkEligibleContactCount}
                        setContactUploading={setContactUploading}
                        tableLoading={loading}
                        activeTab={activeTab}
                        setTableLoading={tableLoadingFn}
                        setFilterLoading={filterLoadingFn}
                        id="addContactBtnEmpty"
                        pageType="contacts"
                        isFromScheduleSeq={false}
                        contactLimit={contactLimit}
                      />
                      <FeatureDemoVideo
                        name={"Add Contacts"}
                        linkText={`How to Add contacts on Salesgear`}
                        type={"contactsPage"}
                      />
                    </>
                  )}
                </div>
              )
            )}
          </div>
        </div>
        <PaginationComponent
          callback={paginate}
          loading={loading}
          totalPages={totalPages}
          currentPage={contactData?.currentPage || 1}
        />
      </div>
    </>
  );
});

export { RenderContactTable };
export default RenderContactTable;
